import * as React from 'react';

import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {
  SubTitleLarge,
  BodyLarge,
} from '@spaced-out/ui-design-system/lib/components/Text';

import ResetImage from 'src/images/reset-phone-icon.svg';
import css from './authenticator-app-reset.css';


const AuthenticatorAppReset = () => {
  const {t} = useLabelTranslation();
  return (
    <div className={css.container}>
      <ResetImage />
      <SubTitleLarge className={css.titleText}>
        {t('Pending_admin_approval', 'Pending admin approval')}
      </SubTitleLarge>
      <BodyLarge className={css.infoText}>
        {t(
          'An_email_with_a_link_to_reset_your_authenticator_app_has_been_sent_to_your_administrator_for_approval',
          'An email with a link to reset your authenticator app has been sent to your administrator for approval.',
        )}
      </BodyLarge>
    </div>
  );
};

export default AuthenticatorAppReset;
